<nz-layout class="layout">
  <nz-header class="notPrintable">
    <div class="logo"><a
        [routerLink]="homeUrl"><img
          [src]="siteLogo ? siteLogo : './assets/images/PaybevLogo.png'"></a></div>
    <div class="mobile-menu">
      <button class="BurgerMenu" type="button">
        <p class="menu-btn" (click)="isVisibleMenu = true">Menu</p>
      </button>
    </div>

    <ul nz-menu nzTheme="dark" nzMode="horizontal" class="header-menu">
      <li class="logout-mobile" nz-menu-item (click)="_cS.logOut();removeClass()"><a>Log
          out</a></li>
      <li *ngIf="canViewSummary" nz-menu-item [routerLink]="'/supplier/'+supplierId+'/summary'"
        [nzSelected]="currentUrl.includes('summary')" (click)="removeClass()">SUMMARY</li>
      <li *ngIf="canViewActivity" nz-menu-item [routerLink]="'/supplier/'+supplierId+'/activity-detailed'"
        [nzSelected]="currentUrl.includes('activity-detailed')" (click)="removeClass()">
        ACTIVITY</li>
      <li *ngIf="canViewPrograms" class="m-d-none" nz-menu-item [routerLink]="'/supplier/'+supplierId+'/programs'"
        [nzSelected]="currentUrl.includes('programs') || currentUrl.includes('content') || currentUrl.includes('brands') || currentUrl.includes('faq')"
        (click)="removeClass()">PROGRAMS
      </li>
      <li class="m-d-none" *ngIf="canViewReports" nz-menu-item
        [routerLink]="'/supplier/'+supplierId+'/report-activity-export'" [nzSelected]="currentUrl.includes('report')">
        REPORTS</li>
      <li *ngIf="(sitesCount + supplierCount + supplierBankSitesCount) > 1" class=" mobile-switch-account-btn"
        [routerLink]="'/switch-account'"><button nz-button class="addButton medium-btn white-border-btn"
          nzType="primary">Switch account
        </button>
      </li>
    </ul>

    <div class="header-right">
      <ul>
        <li class="client-name-text site-name-text mobile-none" nz-tooltip
          [nzTooltipTitle]="siteName?.length > 9 ? siteName : ''" nzTooltipPlacement="bottomLeft">{{siteName}}</li>
        <li class="desktop-btn" [routerLink]="'/switch-account'"
          *ngIf="(sitesCount + supplierCount + supplierBankSitesCount) > 1">
          <button nz-button class="addButton medium-btn white-border-btn" nzType="primary">Switch account
          </button>
        </li>
        <!-- <li (click)="showAnnouncemnts()">
          <nz-badge [nzCount]="notificationsCount"><img class="notification-setting-icon cursor"
              src="./assets/images/notifications.svg"></nz-badge><span class="cl-white"></span>
        </li> -->
        <li>
          <app-profile-menu [user]="userInfo" [siteId]="supplierId" [siteName]="siteName" [settingUrl]="settingUrl"
            [hasSettingsPage]="hasSettingsPage" (signOut)="logout()"></app-profile-menu>
        </li>
      </ul>
    </div>
  </nz-header>
  <nz-layout class="right-layout" [class.account-layout]="isAccountSettingsView"
    [ngClass]="currentUrl.includes('summary') || currentUrl.includes('activity-simple') || currentUrl.includes('activity-detailed') || (currentUrl.includes('payments') && !currentUrl.includes('report')) || (currentUrl.includes('investments') && !currentUrl.includes('report')) || currentUrl.includes('my-profile') || currentUrl.includes('transaction') || currentUrl.includes('help')|| currentUrl.includes('programs') || currentUrl.includes('content')|| currentUrl.includes('brands') || currentUrl.includes('faq') ? 'ml-0':''">
    <nz-sider class="side-menu-width" nzTheme="light"
      *ngIf="currentUrl.includes('users') || currentUrl.includes('notifications') || currentUrl.includes('tutorials')">
      <div class="sider-menu">
        <ul nz-menu nzMode="inline">
          <li *ngIf="canViewUsers" nz-menu-item [nzSelected]="currentUrl.includes('users')"><a
              [routerLink]="'/supplier/'+supplierId+'/users'">Users</a></li>
          <li *ngIf="canViewNotifications" nz-menu-item [nzSelected]="currentUrl.includes('notifications')"><a
              [routerLink]="'/supplier/'+supplierId+'/notifications'">Notifications</a></li>
        </ul>
      </div>
    </nz-sider>
    <nz-sider class="side-menu-width" *ngIf="currentUrl.includes('report')">
      <div class="sider-menu">
        <ul nz-menu nzMode="inline">
          <li nz-menu-item [nzSelected]="currentUrl.includes('activity-export')"><a
              [routerLink]="'/supplier/'+supplierId+'/report-activity-export'">Activity Export</a></li>
        </ul>
      </div>
    </nz-sider>
    <nz-sider class="side-menu-width account-sider" *ngIf="currentUrl.includes('/user-profile/')">
      <app-account-sidebar section="profile" [siteId]="supplierId" [currentUrl]="currentUrl"></app-account-sidebar>
    </nz-sider>
    <nz-sider class="side-menu-width account-sider" *ngIf="currentUrl.includes('/security/')">
      <app-account-sidebar section="security" [siteId]="supplierId" [currentUrl]="currentUrl"></app-account-sidebar>
    </nz-sider>
    <nz-content style="overflow-y: auto;" class="content-container"
      [class.account-settings-content]="isAccountSettingsView"
      [class.account-inline-footer]="currentUrl.includes('/user-profile/access') || currentUrl.includes('/user-profile/details')">
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
      <div class="main-footer-container"><span nz-icon class="pr-2px" nzType="copyright"
          nzTheme="outline"></span>{{currentYear}} | PayBev <sup class="footer-sup">TM</sup></div>
    </nz-content>
  </nz-layout>
</nz-layout>
<nz-drawer [nzVisible]="isVisibleMenu" nzPlacement="left" [nzTitle]="drawerheader" [nzClosable]="false"
  (nzOnClose)="handleCancelisVisibleMenu()" nzWidth="85%" nzWrapClassName="menudrawer">
  <ng-template #drawerheader>
    <a (click)="_cS.logOut();removeClass()">LogOut</a>
  </ng-template>
  <ng-container *nzDrawerContent>
    <nz-avatar class="m-3" [nzText]="supplierDetails?.investorDisplayName.charAt(0).toUpperCase()"
      [nzSrc]="supplierDetails?.Profile" [nzSize]="120"></nz-avatar>
    <ul nz-menu nzTheme="dark" nzMode="vertical" class="center">
      <li *ngIf="canViewSummary" nz-menu-item [routerLink]="'/supplier/'+supplierId+'/summary'"
        [nzSelected]="currentUrl.includes('summary')" (click)="isVisibleMenu = false">SUMMARY</li>
      <li *ngIf="canViewActivity" nz-menu-item [routerLink]="'/supplier/'+supplierId+'/activity-detailed'"
        [nzSelected]="currentUrl.includes('activity-detailed')" (click)="isVisibleMenu = false">
        ACTIVITY</li>
      <li nz-menu-item [routerLink]="'/supplier/'+supplierId+'/help-and-support'"
        [nzSelected]="currentUrl.includes('help-and-support')" (click)="isVisibleMenu = false">
        HELP & SUPPORT</li>
      <hr />
      <li class="mobile-switch-account-btn mt-1" [routerLink]="'/switch-account'"
        *ngIf="(sitesCount + supplierCount + supplierBankSitesCount) > 1">
        <button nz-button class="addButton medium-btn white-border-btn" style="display:inline" nzType="primary">Switch
          account</button>
      </li>
    </ul>
    <!-- Phones hide the User Profile / Security sider (see SCSS); its menu moves into this drawer. -->
    <div class="account-drawer-nav" *ngIf="isAccountSettingsView" (click)="isVisibleMenu = false">
      <app-account-sidebar [section]="accountSection" [siteId]="supplierId" [currentUrl]="currentUrl"></app-account-sidebar>
    </div>
  </ng-container>

</nz-drawer>
<app-changepassword *ngIf="isVisivleChangePassword" (hideChangePassword)="hideChangePassword($event)">
</app-changepassword>

<app-notifications-announcements *ngIf="isVisibleAnnouncements"
  (hideAnnouncements)="hideAnnouncements($event)"></app-notifications-announcements>